import React, { useState } from 'react';
import JugadorDetalle from './JugadorDetalle';

const API_URL = process.env.REACT_APP_API_URL || 'https://lossaliasfutbolclub.com/api';

const statusColors = {
  activo: 'bg-green-100 text-green-800',
  prueba: 'bg-yellow-100 text-yellow-800',
  retirado: 'bg-red-100 text-red-800',
  lesionado: 'bg-orange-100 text-orange-800',
};

const MisJugadores = ({ jugadores, loading }) => {
  const [selectedJugadorId, setSelectedJugadorId] = useState(null);

  if (selectedJugadorId) {
    return (
      <JugadorDetalle
        jugadorId={selectedJugadorId}
        onBack={() => setSelectedJugadorId(null)}
      />
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-lsfc-green-600"></div>
      </div>
    );
  }

  if (!jugadores || jugadores.length === 0) {
    return (
      <div className="text-center py-12">
        <span className="text-5xl">⚽</span>
        <h3 className="text-lg font-bold text-gray-600 mt-3">No hay jugadores registrados</h3>
        <p className="text-gray-400 mt-1 text-sm">Tus jugadores aparecerán aquí una vez inscritos.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-bold text-gray-800">
        Mis Jugadores ({jugadores.length})
      </h2>
      <p className="text-xs text-gray-400">Toca un jugador para ver sus datos completos</p>

      {jugadores.map((jugador) => (
        <button
          key={jugador.id}
          onClick={() => setSelectedJugadorId(jugador.id)}
          className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-4 text-left hover:shadow-lg transition-shadow active:scale-[0.98]"
        >
          {/* Photo or placeholder */}
          <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-100 flex items-center justify-center">
            {jugador.foto_url ? (
              <img
                src={`${API_URL.replace('/api', '')}/uploads/documentos/${jugador.foto_url}`}
                alt={jugador.nombres}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<span class="text-3xl">⚽</span>';
                }}
              />
            ) : (
              <span className="text-3xl">⚽</span>
            )}
          </div>

          {/* Player info */}
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-gray-800 truncate">
              {jugador.nombres} {jugador.apellidos}
            </h3>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              {jugador.edad && (
                <span className="text-xs text-gray-500">{jugador.edad} años</span>
              )}
              {jugador.cedula && (
                <span className="text-xs text-gray-400">• {jugador.cedula}</span>
              )}
            </div>
            <div className="mt-2 flex flex-wrap gap-1">
              {jugador.categoria && (
                <span className="text-xs px-2 py-0.5 rounded-full font-bold bg-indigo-100 text-indigo-800">
                  {jugador.categoria}
                </span>
              )}
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColors[jugador.status] || 'bg-gray-100 text-gray-600'}`}>
                {jugador.status || 'Sin status'}
              </span>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex-shrink-0 text-gray-400">
            <span className="text-lg">→</span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default MisJugadores;
